module.exports = __webpack_public_path__ + "static/media/10_William_F@2x.c313edfe.jpg";